// LIBRARIES
import styled, { css } from "styled-components";
import CancelIcon from "@mui/icons-material/Cancel";

// MISC
import { COLORS, FONTS } from "constants/styleVariables";

export const ConfirmationModalContainer = styled.div`
  height: 364px;
  width: 500px;
  border-radius: 20px;
  background-color: ${COLORS.primaryWhite};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  outline: none;
  padding: 40px;
`;

export const CloseIcon = styled(CancelIcon)`
  && {
    position: absolute;
    top: 5%;
    right: 5%;
    color: ${COLORS.thirdGray};
    padding: 0;
    margin-bottom: 0;
    cursor: pointer;
  }
`;

export const AddArticleModalContainer = styled.div`
  height: 864px;
  width: 600px;
  border-radius: 20px;
  background-color: ${COLORS.primaryWhite};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  outline: none;
  padding: 40px;
`;

export const InputAtomContainer = styled.div(
  ({ width }) => css`
  margin-right: auto;
  margin-left: auto;
    // margin-bottom: 20px;
    // padding-right: 20px;
    width: ${width ? width : "90%"};
  `
);

export const InputsWrapper = styled.div`
  width: 100%;
  height: 620px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const HeaderContainer = styled.div `
    font-size: 30px;
    font-family: ${FONTS.poppins};
    color: ${COLORS.terraCotta};
    font-weight: bold;
    text-align: center;
  `;

export const TextContainer = styled.div`
  font-family: ${FONTS.montserrat};
  font-size: 18px;
  color: ${COLORS.rainbowIndigo};
  margin-top: 20px;
  font-weight: 600;
  text-align: center;
`;

export const ButtonsWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
`;
